import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Chip from '../Chip/Chip'
import EmptyState from '../EmptyState/EmptyState'
import styles from './RecommendationsList.module.scss'

function RecommendationMessage({ id, values = {} }) {
  const resolvedValues = {
    ...values,
    license: values.licenseLabelId ? <FormattedMessage id={values.licenseLabelId} /> : values.license,
  }
  return <FormattedMessage id={id} values={resolvedValues} />
}

RecommendationMessage.propTypes = {
  id: PropTypes.string.isRequired,
  values: PropTypes.shape({}),
}

export default function RecommendationsList({ items = [] }) {
  if (items.length === 0) {
    return (
      <div className={styles.emptyState}>
        <EmptyState messageId="AI_RISK_REPORT.RECOMMENDATIONS_EMPTY" />
      </div>
    )
  }

  return (
    <ol className={`${styles.list} p-0`}>
      {items.map((item, index) => (
        <li key={item.key} className={`${styles.item} d-grid gap-3 bg-transparent`}>
          <span className={`${styles.number} d-grid`}>{index + 1}</span>
          <div>
            <div className={styles.title}>
              {item.title ?? <RecommendationMessage id={item.titleId} values={item.values} />}
            </div>
            {(item.description || item.descriptionId) && (
              <div className={styles.description}>
                {item.description ?? <RecommendationMessage id={item.descriptionId} values={item.values} />}
              </div>
            )}
            {item.tags?.length > 0 && (
              <div className={`${styles.tags} d-flex flex-wrap gap-2`}>
                {item.tags.map((tag) => (
                  <Chip key={tag.labelId} tone={tag.tone}>
                    <FormattedMessage id={tag.labelId} />
                  </Chip>
                ))}
              </div>
            )}
          </div>
        </li>
      ))}
    </ol>
  )
}

RecommendationsList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      type: PropTypes.oneOf(['configuration', 'license']),
      title: PropTypes.node,
      titleId: PropTypes.string,
      description: PropTypes.node,
      descriptionId: PropTypes.string,
      values: PropTypes.shape({}),
      tags: PropTypes.arrayOf(PropTypes.shape({ labelId: PropTypes.string.isRequired, tone: PropTypes.string })),
    }),
  ),
}
